import ServicesRegionalCapabilities from './ServicesRegionalCapabilities';

export { type ServicesRegionalCapabilitiesProps } from './ServicesRegionalCapabilities';
export default ServicesRegionalCapabilities;
